import { FDStack, FDLozenge, FDBodyText } from '@facet-wealth/design';
import PropTypes from 'prop-types';
import React from 'react';
import { useDataAttrs } from 'Helpers/Testing';

export const BackwardsLozengeStat = ({ value, label, ...rest }) => {
  let color = 'info';
  if (value.toLowerCase() === 'yes') {
    color = 'success';
  }
  if (value.toLowerCase() === 'no') {
    color = 'warning';
  }
  return (
    <FDStack {...useDataAttrs(rest)} spacing={1} alignItems="center">
      <FDLozenge label={value} color={color} size="lg" />
      <FDBodyText value={label} />
    </FDStack>
  );
};

BackwardsLozengeStat.defaultProps = {
  value: '',
};

BackwardsLozengeStat.propTypes = {
  value: PropTypes.string,
  label: PropTypes.string.isRequired,
};
